import { Redirect, Route, Switch } from "react-router-dom";

import {
  routeHelperPaystubsDashboard,
  routeHelperPaystubsDetails
} from "./paths";
import { RoutePaystubsDashboard } from "./routes/RoutePaystubsDashboard";
import { RoutePaystubsDetails } from "./routes/RoutePaystubsDetails";
import { getDefaultPaystubsYear } from "./utils";

export const PaystubsIndex: React.FC = () => {
  return (
    <Switch>
      <Route
        component={RoutePaystubsDetails}
        path={routeHelperPaystubsDetails.path}
      />
      <Route
        component={RoutePaystubsDashboard}
        path={routeHelperPaystubsDashboard.path}
      />

      <Redirect
        from="*"
        to={routeHelperPaystubsDashboard.createLocationObject({
          year: getDefaultPaystubsYear()
        })}
      />
    </Switch>
  );
};
